<template>
  <div
    class="w-full flex flex-col justify-center items-center self-center my-16 max-md:my-0"
  >
    <Form
      id="retailerForm"
      ref="retailerForm"
      class="flex flex-wrap justify-evenly gap-5 md:px-10 py-12 shadow-2xl w-full"
      :validation-schema="schema"
    >
      <div class="flex flex-col w-full">
        <div class="w-full px-3 md:mb-0">
          <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="store">
            {{ $t('Store') }} *
          </label>
          <Field
            id="retailer"
            v-model:model-value="selectedRetailer"
            name="retailer"
            as="select"
            rules="required"
            :placeholder="$t('Store')"
            class="w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight"
            @update:model-value="selectRetailer()"
          >
            <option disabled selected value="">Magazin</option>
            <option v-for="option in retailers" :key="option.name" :value="option.id" :disabled="option.disabled || false">
              {{ option.name }}
            </option>
          </Field>
          <small class="form-text text-red-400">
            <ErrorMessage name="retailer" />
          </small>
        </div>
        <div class="px-3 md:mb-0">
          <Field id="tnc" v-model:model-value="receiptStore.retailerForm.tnc" name="terms" type="checkbox" :value="true" /> Am citit și accept <a href="#" @click="openTerms">Regulamentul campaniei</a>.
          <small class="form-text text-red-400">
            <ErrorMessage name="terms" />
          </small>
        </div>
      </div>
    </Form>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useReceiptStore, useCampaignStore } from '@/stores'
import { Form, Field, ErrorMessage } from 'vee-validate'
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const receiptStore = useReceiptStore()
const campaignStore = useCampaignStore()
const campaign = campaignStore.getActiveCampaign
const retailerForm = ref(null)
const selectedRetailer = ref(null)

defineExpose({
  validate: () => retailerForm.value.validate()
})

const retailers = computed(() => campaignStore.retailers)

const selectRetailer = () => {
  const retailer = retailers.value.find(r => r.id === selectedRetailer.value)
  receiptStore.setRetailer(retailer)
}

const schema = {
  terms: (value) => {
    if (value) {
      return true;
    }
    return t('You must agree to the terms and conditions.');
  },
  retailer: { required: true, },
};

const openTerms = () => {
  const link = `${campaign.tnc}?_=${new Date().getTime()}`
  window.open(link, '_blank')
}

</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}
</style>